import { KmapJsxGraph } from './KmapJsxGraph.js';

window.customElements.define('kmap-jsxgraph', KmapJsxGraph);
